/** HTTP ステータスを保持する Error。再試行で回復しない 401 を呼び出し側で判別するために使う。 */
export class HttpStatusError extends Error {
  readonly status: number;

  constructor(message: string, status: number) {
    super(message);
    this.name = 'HttpStatusError';
    this.status = status;
  }
}

export function isUnauthorizedError(error: unknown): boolean {
  return error instanceof HttpStatusError && error.status === 401;
}

/** 401（未ログイン/失効）と 403（権限なし）。再試行しても回復しないので自動再試行を止める対象。 */
export function isAuthFailureError(error: unknown): boolean {
  return error instanceof HttpStatusError && (error.status === 401 || error.status === 403);
}
